export enum ClientRoutes {
    entity = 'entity',
}
